/**
 * Сервис для работы с API отчетов (версия 2.0 с БД)
 */

import apiService from './apiService'

export default {
  /**
   * Запуск генерации отчета
   * @returns {Promise<Object>} Объект отчёта с ID
   */
  async generateReport() {
    try {
      const response = await apiService.post('/price-report/generate')
      return response.data
    } catch (error) {
      console.error('Error generating report:', error)
      throw error
    }
  },

  /**
   * Скачивание готового отчета
   * @param {number} reportId - ID отчёта
   */
  async downloadReport(reportId) {
    try {
      const response = await apiService.get(`/price-report/download/${reportId}`, {
        responseType: 'blob'
      })

      // Извлекаем имя файла из заголовков
      const contentDisposition = response.headers['content-disposition']
      let filename = `price_report_${new Date().toISOString().split('T')[0]}.xlsx`
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '')
        }
      }

      // Создаем ссылку и автоматически скачиваем файл
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      return { success: true, filename }
    } catch (error) {
      console.error('Error downloading report:', error)
      throw error
    }
  },

  /**
   * Получение списка всех отчётов
   * @param {Object} params - Параметры фильтрации
   * @param {string} params.report_type - Тип отчёта (опционально)
   * @param {string} params.status - Статус (опционально)
   * @param {number} params.limit - Лимит записей (по умолчанию 50)
   * @returns {Promise<Array>} Список отчётов
   */
  async listReports(params = {}) {
    try {
      const response = await apiService.get('/price-report/reports', { params })
      return response.data
    } catch (error) {
      console.error('Error listing reports:', error)
      throw error
    }
  },

  /**
   * Удаление отчёта
   * @param {number} reportId - ID отчёта
   */
  async deleteReport(reportId) {
    try {
      const response = await apiService.delete(`/price-report/report/${reportId}`)
      return response.data
    } catch (error) {
      console.error('Error deleting report:', error)
      throw error
    }
  }
}
